import { Header, Title, Footer } from "../components"; // Added Footer
import profilePic from "../assets/images/mauro/mauro-outside-van.jpg";
import phoneIcon from "../assets/icons/phone.svg"; // Renamed for clarity
import emailIcon from "../assets/icons/email.svg";
import facebookIcon from "../assets/icons/facebook.svg";
import styles from "./Contact.module.css";

export const Contact = () => {
  return (
    <div className={styles.contactBackground}>
      <Header linksStyle="" />
      <Title text={"Get in Touch - Book Your Service!"} size={28} />
      <div className={styles.main}>
        <div className={styles.profile}>
          <img src={profilePic} alt="Mauro Massari - Massari Auto Service" />
        </div>
        <div className={styles.details}>
          <div className={styles.name}>Mauro Massari</div>
          <div className={styles.info}>Heavy Duty Diesel Mechanic</div>
          <div className={styles.info}>Auto Electrician</div>
          <div className={styles.insured}>Australian-Insured Business</div>

          <div className={styles.contactMethods}>
            <a
              href="sms:0413119343;?body=Suburb:%0D%0AService required:%0D%0AVehicle make/model:"
              className={`${styles.contactButton} ${styles.smsButton}`}
            >
              <img src={phoneIcon} alt="SMS" className={styles.icon} />
              <span>
                SMS Booking:
                <br />
                0413 119 343
              </span>
            </a>
            <a
              href="mailto:mauromassaribr@gmail.com"
              className={`${styles.contactButton} ${styles.emailButton}`}
            >
              <img src={emailIcon} alt="Email" className={styles.icon} />
              <span>
                Email Us:
                <br />
                mauromassaribr@gmail.com
              </span>
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=100075687891593"
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles.contactButton} ${styles.facebookButton}`}
            >
              <img src={facebookIcon} alt="Facebook" className={styles.icon} />
              <span>
                Visit Us On:
                <br />
                Facebook
              </span>
            </a>
          </div>
          {/* TODO: Optional: Add a section for a map or service area description */}
          {/*
                    <div className={styles.mapSection}>
                        <h4>Our Service Area</h4>
                        <p>Placeholder: We primarily serve the [Your City/Region] area. Contact us to confirm if we cover your location.</p>
                        <div className={styles.mapPlaceholder}>[Placeholder: Embedded Google Map or Image of Service Area]</div>
                    </div>
                    */}

          {/* TODO: Optional: Add a simple contact form if desired instead of/in addition to direct links */}
          {/*
                    <div className={styles.contactFormSection}>
                        <h4>Or Send Us a Message</h4>
                        <form className={styles.contactForm}>
                            <input type="text" placeholder="Your Name" required />
                            <input type="email" placeholder="Your Email" required />
                            <input type="tel" placeholder="Your Phone (Optional)" />
                            <textarea placeholder="Your Message / Service Required" rows="4" required></textarea>
                            <button type="submit" className={styles.formSubmitButton}>Send Message</button>
                        </form>
                    </div>
                    */}
        </div>
      </div>
      <Footer />
    </div>
  );
};
